import {Button} from "@chakra-ui/react";
import BraintreeDropIn from "braintree-web-drop-in";
import {useIntl} from 'next-intl';
import React, {useEffect, useState} from "react";

import useShoppingCart from "../../hooks/useShoppingCart";


function CreditCardForm(props) {
    const intl = useIntl();
    const {onNonceGeneratedSuccessfully, isFormInformationComplete, children} = props;
    const {shoppingCartClientToken, shoppingCartTotal, isLoading, isShoppingCartTotalNil} = useShoppingCart()
    const [isPaymentMethodValid, setIsPaymentMethodValid] = useState(false)

    const [braintreeInstance, setBraintreeInstance] = useState()

    const initializeBraintree = () => BraintreeDropIn.create({
        authorization: shoppingCartClientToken, // insert your tokenization key or client token here
        container: '#credit-card-drop-in',
    }, (error, instance) => {
        if (error) {
            console.error(error)
        } else {
            setBraintreeInstance(instance);
        }
    });

    const shouldPayNowButtonBeEnabled = isFormInformationComplete && (isShoppingCartTotalNil ? true : (braintreeInstance && isPaymentMethodValid))

    useEffect(() => {
        if (!isLoading) {
            if (braintreeInstance) {
                braintreeInstance
                    .teardown()
                    .then(() => {
                        try {
                            return initializeBraintree();
                        } catch (error) {
                            return setTimeout(() => initializeBraintree(), 1500)
                        }
                    }).catch(() => {
                    console.error('error tearing down braintree instance')
                });
            } else {
                try {
                    initializeBraintree();
                } catch (error) {
                    setTimeout(() => initializeBraintree(), 1500)
                }
            }
        }

    }, [isLoading])

    useEffect(() => {
        if (braintreeInstance) {
            braintreeInstance.on('card:validityChange', ({
                                                             fields: {
                                                                 cvv,
                                                                 expirationDate,
                                                                 number
                                                             }
                                                         }) => setIsPaymentMethodValid([cvv, expirationDate, number].every(({isValid}) => isValid)))
        }
    }, [braintreeInstance])

    const payButtonBody = isShoppingCartTotalNil ? 'Book Now' : `Pay Now (${intl.formatNumber(shoppingCartTotal, {
        style: 'currency',
        currency: 'USD'
    })}) `

    return (<div
    >
        {!isLoading && !isShoppingCartTotalNil && (<div
            id="credit-card-drop-in"
        />)}
        {children}
        <Button
            isLoading={isLoading}
            className="braintreePayButton"
            type="primary"
            disabled={!shouldPayNowButtonBeEnabled}
            onClick={() => {
                if (braintreeInstance) {
                    braintreeInstance.requestPaymentMethod((error, payload) => {
                        if (error) {
                            // TODO: handle credit card errors
                            console.error(error);
                        } else {
                            // TODO: handle payment success
                            const paymentMethodNonce = payload.nonce;
                            onNonceGeneratedSuccessfully(paymentMethodNonce);
                        }
                    });
                } else if (isShoppingCartTotalNil) {
                    onNonceGeneratedSuccessfully('blackout-nonce-override');
                }
            }}
            // fontWeight='bold'
            size="lg"
            colorScheme="orange"
            variant="solid"
            width="100%"
            mb={6}
        >
            {payButtonBody}
        </Button>
    </div>)
}

export default CreditCardForm